import * as React from 'react';
import GroupedFieldsConfiguration, { GroupedFieldsConfigurationProps } from './GroupedFieldsConfiguration';
import SearchableFieldsPanel from './SearchableFieldsPanel';

const ConfigureColumnGroupedFieldsPanel = (props: GroupedFieldsConfigurationProps) => {

    return <SearchableFieldsPanel {...props}>
        {(filter, onEditField) => <GroupedFieldsConfiguration {...props} filter={filter} onEditField={onEditField} />}
    </SearchableFieldsPanel>
}

export default ConfigureColumnGroupedFieldsPanel;
